import Icon from "./../../icons/icon";

import styles from "./footer.module.css";
import Button from "./../../components/button/button";

import Video from "../../assets/video/hero.mp4";
import { useEffect, useState } from "react";

import axios from "axios";

const Footer = ({ data }) => {
  const [left, setLeft] = useState(0);

  const [email, setEmail] = useState("");
  const [error, setError] = useState(false);

  const [success, setSuccess] = useState(false);

  const handleClick = () => {
    if (isValidEmail(email)) {
      const data = new FormData();
      data.append("email", email);

      axios({
        method: "post",
        url: "/contact/contact.php",
        headers: { "content-type": "multipart/form-data" },
        data,
      })
        .then((result) => {
          setEmail("");
          setSuccess(true);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      setError(true);
    }
  };

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleChange = (event) => {
    setError(false);
    setEmail(event.target.value);
  };

  useEffect(() => {
    const container = document.querySelector(".narrow-container");

    const handleLeft = () => {
      setLeft(container.getBoundingClientRect().left);
    };

    handleLeft();

    window.addEventListener("resize", handleLeft);

    return () => {
      window.removeEventListener("resize", handleLeft);
    };
  }, []);

  return (
    <div className={styles.footerWrapper}>
      <div className={styles.video} style={{ left }}>
        <div className={styles.overlay}></div>
        <div className={styles.overlay2}></div>
        <video muted loop autoPlay playsInline>
          <source src={Video} type="video/mp4" />
        </video>
      </div>
      <div className={`${styles.footer} narrow-container`}>
        <div className={styles.top}>
          <h2>
            {data?.titleLine1} <br /> {data?.titleLine2}
          </h2>

          <Button>Get started</Button>
        </div>

        <div className={styles.inputWrapper}>
          <div className={styles.label}> {data?.inputLabel}</div>

          <div className={`${styles.input} ${error ? styles.error : ""}`}>
            <input
              type="text"
              placeholder="your@email.com"
              value={email}
              onChange={handleChange}
            />

            <div className={styles.arrow} onClick={handleClick}>
              <Icon type="Arrow" />
            </div>

            {success && (
              <p className={styles.success}>Thank you for subscribing!</p>
            )}
          </div>
        </div>

        <div className={styles.copyright}>
          <p className={styles.copyText}>{data?.copyright}</p>

          <div className={styles.links}>
            <p> {data?.items[0]}</p>

            <p> {data?.items[1]}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
